import styled, { css } from 'styled-components';
import circle from '../../assets/images/shadow_up_element.png';

const StyledBgCircle = styled.div<{ $position: 'left' | 'right' }>`
	position: absolute;
	top: 0;
	${({ $position }) =>
		$position === 'left' &&
		css`
			left: 0;
			transform: scaleX(-1);
		`}
	${({ $position }) =>
		$position === 'right' &&
		css`
			right: 0;
		`}
	width: 410px;
	height: 410px;
	background-image: url(${circle});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
`;

export { StyledBgCircle };
